import React from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import NativeSafeSelect from "./ui/NativeSafeSelect.jsx";

const LANGS = [
  { code: "ru", key: "languages.ru", fallback: "Русский", enabled: true },
  { code: "uz", key: "languages.uz", fallback: "Ўзбекча", enabled: true },
  { code: "tr", key: "languages.tr", fallback: "Türkçe", enabled: true },
];

export default function LanguageSelector() {
  const { t, i18n } = useTranslation();
  const current = String(i18n.resolvedLanguage || i18n.language || "ru").split("-")[0];

  const soonSuffix =
    current === "uz" ? " (tez kunda)" :
    current === "tr" ? " (yakında)" :
    i18next.t("common.soonSuffix");

  const setLang = async (lng) => {
    try {
      localStorage.setItem("gptcargo_lang", lng);
    } catch {}
    try {
      await i18n.changeLanguage(lng);
    } catch {}
  };

  React.useEffect(() => {
    const enabled = LANGS.some((l) => l.code === current && l.enabled);
    if (!enabled) setLang("ru");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);

  return (
    <div
      className="driver-language-selector"
      style={{
        width: "100%",
        marginBottom: 0,
      }}
    >
      <label
        style={{
          display: "block",
          color: "#e2e8f0",
          fontSize: 14,
          fontWeight: 700,
          marginBottom: 8,
          letterSpacing: "0.02em",
        }}
      >
        {t("settings.language", { defaultValue: "Язык" })}
        <span
          style={{
            color: "#60a5fa",
            fontSize: 12,
            fontWeight: 600,
            marginLeft: 6,
          }}
        >
          ({current})
        </span>
      </label>

      <NativeSafeSelect
          value={LANGS.some((l) => l.code === current && l.enabled) ? current : "ru"}
          onChange={setLang}
          ariaLabel={t("settings.language", { defaultValue: "Язык" })}
          placement="auto"
          options={LANGS.map((l) => ({
            value: l.code,
            label: `${t(l.key, l.fallback)}${l.enabled ? "" : soonSuffix}`,
            disabled: !l.enabled,
          }))}
          style={{
            width: "100%",
            boxSizing: "border-box",
            padding: "15px 16px",
            borderRadius: 16,
            border: "1px solid #475569",
            background: "rgba(30, 41, 59, 0.96)",
            color: "#f8fafc",
            fontSize: 18,
            fontWeight: 500,
            outline: "none",
          }}
          menuClassName="absolute left-0 right-0 z-[99999] max-h-56 overflow-y-auto overscroll-contain rounded-2xl border border-slate-700 bg-slate-950 shadow-2xl"
        />
    </div>
  );
}
